// Put your main actions here
import axios from "axios";
import router from "../router/index";
import Vue from "vue";

export default {
  updateProcessMarkedRows: ({ commit }, payload) => {
    commit("updateMarkedRows", payload);
  },
  toggleOverlay: ({ commit }) => {
    commit("toggleOverlay");
  },
  increment: ({ commit }) => {
    commit("increment");
  },
  expireSession: ({ commit, dispatch, state }) => {
    if (!state.user.ACTIVO) {
      setTimeout(() => {
        dispatch("logout");
      }, 20);
    }
  },
  login: ({ commit }, payload) => {
    return new Promise((resolve, reject) => {
      commit("auth_request");
      commit("showOverlay");
      axios
        .post("/menu_app/authenticate/", payload)
        .then((response) => {
          const payload = {
            token: response.data.token,
            id_client: response.data.id_client,
            id_usuario: response.data.id_user,
            image: response.data.image,
            logo: response.data.logo,
            scope: response.data.scope,
            usuario: response.data.username,
            menu_user: response.data.menu,
            is_active: response.data.is_active,
            is_director: response.data.is_director,
            is_staff: response.data.is_staff,
            is_superuser: response.data.is_superuser,
            proforma_type: response.data.proforma_type,
            client_details: response.data.client_details,
            waybill_custom_fields: response.data.waybill_custom_fields,
            content_custom_fields: response.data.content_custom_fields,
            custom_components: response.data.custom_components
          };
          localStorage.setItem("image", payload.logo);
          // localStorage.setItem("img", "img/logos/" + payload.image);
          localStorage.setItem("img", payload.logo);
          axios.defaults.headers.common["Authorization"] = "token " + payload.token;
          commit("auth_success", payload);
          commit("hideOverlay");
          resolve(response);
        })
        .catch(function (error) {
          commit("hideOverlay");
          commit("auth_error");
          localStorage.removeItem("token");
          reject(error);
        });
    });
  },
  logout({ commit }) {
    return new Promise((resolve, reject) => {
      commit("logout");
      localStorage.removeItem("token");
      localStorage.removeItem("menu");
      Vue.$cookies.remove("username");
      Vue.$cookies.remove("password");
      delete axios.defaults.headers.common["Authorization"];
      router.push("/pages/login");
      resolve();
    });
  },

  getCustomers: ({ commit }, payload) => {
    return new Promise((resolve, reject) => {
      axios
        .get("/production/get_customers/")
        .then((res) => {
          const data = res.data.data;
          const customers = [];
          for (let key in data) {
            const customer = data[key];
            customers.push(customer);
          }
          customers.unshift({ text: "Seleccione...", value: "" });
          payload = customers;
          commit("getCustomers", payload);
          resolve(res);
        })
        .catch((error) => {
          console.log(error);
          reject(error);
        });
    });
  }
};
